export { FastshiftTeamCard } from './fastshift-team-card';
